import React from "react";

export function IndicadorSituacaoUc(props) {
    let situacao = "Ativa";

    if (!props.item.ativo) {
        situacao = "Inativa";
    } else if (props.item.ativo && props.item.data_desligamento) {
        const desligada = new Date(props.item.data_desligamento) <= new Date();
        situacao = desligada ? "Desligada" : "Desligamento Agendado";
    }

    return (
        <>
            {props.item.usuario_implantacao ? (
                <p
                    style={{
                        backgroundColor: "#257bfb",
                        textAlign: "center",
                        borderRadius: "0.3rem",
                        color: "#fff",
                        margin: "2px 10px 2px 2px",
                        padding: "2px 5px",
                    }}
                >
                    Implantação
                </p>
            ) : null}
            <span>{situacao}</span>
        </>
    );
}
